import {
  Dialog,
  Button,
  FormField,
  FormGrid,
  FormRow,
} from "@endya-conformite/ui-kit";
import InfoCircle from "@endya-conformite/ui-kit/src/assets/icons/info-circle-fill.svg?react";
import XLg from "@endya-conformite/ui-kit/src/assets/icons/x-lg.svg?react";
import { MutableRefObject } from "react";
import styles from "./EntreprisePaymentSepaConfirmDialog.module.scss";

export function EntreprisePaymentSepaConfirmDialog({
  dialogRef,
  onClose,
}: {
  onClose: (shouldContinue: boolean) => void;
  dialogRef: MutableRefObject<HTMLDialogElement | null>;
}) {
  return (
    <Dialog dialogRef={dialogRef}>
      <FormGrid>
        <FormRow>
          <FormField>
            <h3>Vous avez choisi le prélèvement SEPA</h3>
          </FormField>
        </FormRow>
        <FormRow>
          <FormField className={styles.title}>
            <InfoCircle className={styles.warning} />
            Délai nécessaire habituel de{" "}
            <strong className={styles.warning}>10 jours ouvrés</strong>
          </FormField>
        </FormRow>
        <FormRow>
          <FormField>
            En validant le règlement par prélèvement Sepa, vous confirmez avoir
            pris connaissance du délai de 10 jours ouvrés, lié au crédit de ce
            dernier, pour obtenir votre attestation d&apos;adhésion.
          </FormField>
        </FormRow>
        <FormRow>
          <FormField>
            Vous pouvez annuler et choisir un autre mode de règlement.
          </FormField>
        </FormRow>
        <FormRow>
          <FormField className={styles.actions}>
            <Button
              icon={<XLg />}
              variant="text"
              onClick={() => onClose(false)}
            >
              Annuler
            </Button>
            <Button onClick={() => onClose(true)}>J&apos;ai compris</Button>
          </FormField>
        </FormRow>
      </FormGrid>
    </Dialog>
  );
}
